var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPointer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 27,
    fill: "none",
    viewBox: "0 0 24 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M9 1.5a2.25 2.25 0 0 0-2.25 2.25v5.325a3.75 3.75 0 0 0-3 3.675v2.308a5.25 5.25 0 0 0 .978 3.051l2.239 3.135a3 3 0 0 0 2.44 1.256h5.787a3 3 0 0 0 2.605-1.512l1.76-3.078a5.25 5.25 0 0 0 .691-2.605V12.75a3.75 3.75 0 0 0-3.57-3.746 2.245 2.245 0 0 0-2.784-.465 2.248 2.248 0 0 0-2.646-.911V3.75A2.25 2.25 0 0 0 9 1.5Z",
    clipRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2E2B32",
    fillRule: "evenodd",
    d: "M9 1.5a2.25 2.25 0 0 0-2.25 2.25v5.325a3.75 3.75 0 0 0-3 3.675v2.308a5.25 5.25 0 0 0 .978 3.051l2.239 3.135a3 3 0 0 0 2.44 1.256h5.787a3 3 0 0 0 2.605-1.512l1.76-3.078a5.25 5.25 0 0 0 .691-2.605V12.75a3.75 3.75 0 0 0-3.57-3.746 2.245 2.245 0 0 0-2.784-.465 2.248 2.248 0 0 0-2.646-.911V3.75A2.25 2.25 0 0 0 9 1.5Zm2.25 8.25a.75.75 0 0 1-1.5 0v-6a.75.75 0 0 0-1.5 0v9.75a.75.75 0 0 1-1.5 0v-2.872a2.251 2.251 0 0 0-1.5 2.122v2.308c0 .781.244 1.544.699 2.18l2.238 3.134a1.5 1.5 0 0 0 1.22.628h5.787a1.5 1.5 0 0 0 1.303-.756l1.759-3.078a3.75 3.75 0 0 0 .494-1.861V12.75a2.25 2.25 0 0 0-1.5-2.122v.622a.75.75 0 0 1-1.5 0v-.75a.75.75 0 0 0-1.5 0 .75.75 0 0 1-1.5 0v-.75a.75.75 0 0 0-1.5 0Z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: 22.5,
    height: 27,
    x: 0.75,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0705882 0 0 0 0 0.0745098 0 0 0 0 0.101961 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_96360_46132"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_96360_46132",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointer);
export default __webpack_public_path__ + "static/media/Pointer.cae3c9022cc884a1cad0ea778a540634.svg";
export { ForwardRef as ReactComponent };